import React from 'react';
import classNames from 'classnames';

function PayPalButtonTemplate ({ modelAttributes, helpers }) {

	const { hasCheckoutValidationError } = modelAttributes;

	const { paypalButtonId, shouldShowPayPalButton } = helpers;

	const className = classNames('paypalButtonContainer', hasCheckoutValidationError && 'disabled');

	return (
		<>
			{shouldShowPayPalButton && <div className={className} id={paypalButtonId} />}
		</>
	);

}

export default PayPalButtonTemplate;
